import { Alpha3Code } from 'i18n-iso-countries'

import { BankDetailsListView } from '@percent/admin-dashboard/api/actions/bankDetails/bankDetails.types'
import { MOCK_SEWA_ORG_ID_1, MOCK_SEWA_ORG_ID_2 } from './mockSewaOnboardingListResponse'

export const MOCK_SEWA_IFSC = 'SBIN0001234'

const baseRow = {
  countryCode: 'IND' as Alpha3Code,
  organisationAddress: '1 Test Street, Mumbai',
  status: 'pending' as const,
  requestDate: '2024-01-15T10:00:00.000Z',
  reference: 'ref_test',
  email: 'org@example.org'
}

export const mockSewaBankDetailsReviewListItems: BankDetailsListView[] = [
  {
    ...baseRow,
    id: 'bank_details_review_test_row_1',
    organisationId: MOCK_SEWA_ORG_ID_1,
    organisationName: 'Sewa Org 1',
    ifscCodes: [MOCK_SEWA_IFSC]
  },
  {
    ...baseRow,
    id: 'bank_details_review_test_row_2',
    organisationId: MOCK_SEWA_ORG_ID_2,
    organisationName: 'Sewa Org 2',
    ifscCodes: ['HDFC0000002']
  }
]

export const mockSewaBankDetailsReviewListResponse = {
  data: mockSewaBankDetailsReviewListItems,
  object: 'bank_details_review',
  totalResults: mockSewaBankDetailsReviewListItems.length,
  pageSize: 50,
  _links: {
    current: 'https://staging-api.poweredbypercent.com/v1/admin/bank-details-reviews'
  }
}
